import request from '@/utils/request'
// 获取排行榜
export function getRankList(data) {
    return request({
        method: 'POST',
        url: `/rank/getRankList`,
        data
    })
}
// 获取用户的排行信息
export function getUserRankInfo() {
    return request({
        method: 'POST',
        url: `/rank/getUserRankInfo`,
    })
}
// 获取我的答题记录
export function getAnswerRecord() {
    return request({
        method: 'POST',
        url: `/user/getAnswerRecord`,
    })
}
// 获取活动详情
export function getActionInfo() {
    return request({
        method: 'POST',
        url: `/action/getActionInfo`,
    })
}
// 获取活动配置信息
export function getActionConfig() {
    return request({
        method: 'POST',
        url: `/actionConfig/getActionConfig`,
    })
}
// 获取答题详情
export function getAnswerRecordInfo(data) {
    return request({
        method: 'POST',
        url: `/user/getAnswerRecordInfo`,
        data
    })
}